import { render, staticRenderFns } from "./ResetAdminPasswordSidebar.vue?vue&type=template&id=df4dd62c&scoped=true&"
import script from "./ResetAdminPasswordSidebar.vue?vue&type=script&lang=js&"
export * from "./ResetAdminPasswordSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ResetAdminPasswordSidebar.vue?vue&type=style&index=0&id=df4dd62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4dd62c",
  null
  
)

export default component.exports